import { Card, CardContent, IconButton } from "@material-ui/core";
import { Cached } from "@material-ui/icons";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  dbKey,
  iconColor,
  iconEdge,
  iconSize,
  sortType,
} from "../../../model/Common";
import {
  fetchListOfficeInfos,
  fetchUpdateSortedOfficeInfos,
  selector as officeStoreSelector,
} from "../../../store/OfficeStore";
import useStyles from "../useStyles";

import PressManagementTable from "./PressManagementTable";

/**
 * PressManagementCardコンポーネント.
 *
 * @return {object} コンポーネント
 */
function PressManagementCard() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // 拠点情報一覧のソート状態State (key: ソート対象キー, type: ソート種別)
  const [sortState, setSortState] = React.useState({
    key: dbKey.pressNo,
    type: sortType.asc,
  });

  // Store情報
  const {
    // 読み込み中フラグ (true: 表示 / false: 非表示)
    isLoading,
    // 拠点情報一覧(工番管理画面向け / ユーザー指定項目でソート済み)
    sortedOfficeInfos,
  } = useSelector(officeStoreSelector);

  // 副作用 (ページ読み込み時)
  React.useEffect(() => {
    // 拠点情報一覧の取得
    dispatch(fetchListOfficeInfos());
    // ソート設定をデフォルトに設定
    setSortState({
      key: dbKey.pressNo,
      type: sortType.asc,
    });
  }, [dispatch]);

  // リロードボタン押下時の処理
  const handleClickReloadButton = () => {
    // 拠点情報一覧の取得
    dispatch(fetchListOfficeInfos());
    // ソート設定をデフォルトに設定
    setSortState({
      key: dbKey.pressNo,
      type: sortType.asc,
    });
  };

  // ソート変更時の処理
  const handleClickSortColumn = (key) => {
    const isDesc = key === sortState.key && sortState.type === sortType.desc;
    const type = isDesc ? sortType.asc : sortType.desc;
    const payload = { key, type };
    setSortState({
      key,
      type,
    });
    dispatch(fetchUpdateSortedOfficeInfos(payload));
  };

  return (
    <>
      <Card className={styles.card}>
        <CardContent className={`${styles.cardContent} ${styles.flexStart}`}>
          <div className={styles.marginLeftAuto}>
            <IconButton
              color={iconColor}
              edge={iconEdge}
              disabled={!sortedOfficeInfos || isLoading}
              onClick={() => handleClickReloadButton()}
            >
              <Cached fontSize={iconSize} />
            </IconButton>
          </div>
        </CardContent>
        <CardContent className={styles.cardContent}>
          <PressManagementTable
            sortState={sortState}
            onHeaderClick={handleClickSortColumn}
          />
        </CardContent>
      </Card>
    </>
  );
}

export default PressManagementCard;
